/* eslint-disable no-unused-vars, max-len */
const { feWp } = window;
const { addAction } = feWp.hooks;

const configureSwiper = ( settings, swiper ) => {
  Object.assign( swiper.params, {
    threshold: 2,
    preventClicks: false,
    preventClicksPropagation: false
  } );
  if ( settings.loop ) {
    Object.assign( swiper.params, {
      supports4k: true,
      longSwipesRatio: 0,
      threshold: 0,
      touchRatio: 0.1
    } );
    swiper.update();
  }
};

const stopAutoPlay = ( sliderObj ) => sliderObj.autoplay.stop();
const startAutoPlay = ( sliderObj ) => sliderObj.autoplay.start();

const setAnimationDuration = ( sliderObj, duration ) => {
  sliderObj.el.querySelectorAll( '.line-animator' )?.forEach( line => {
    line.style.animationDuration = `${duration}ms`;
  } );
};

const handleInteraction = ( swiper, navSwiper, el ) => {
  setAnimationDuration( navSwiper, 0 );
  stopAutoPlay( swiper );
  el.parentNode.classList.add( 'autoplay-stop' );
};

const handleDotsInteraction = ( swiper, navSwiper, el, dots ) => {
  dots.forEach( dot => {
    dot.addEventListener( 'click', () => {
      handleInteraction( swiper, navSwiper, el );
    } );
  } );
};

const changeToFirstSlide = ( sliderObj, settings ) => {
  if( settings.loop ) {
    sliderObj.slideToLoop( 0 );
  } else {
    sliderObj.slideTo( 0 );
  }
};

const setupIntersectionObserver = ( el, swiper, navSwiper, settings ) => {
  const observer = new IntersectionObserver( ( entries ) => {
    entries.forEach( entry => {
      if ( entry.isIntersecting ) {
        el.parentNode.classList.add( 'tab-slider-in-view' );
        if ( settings.autoplay && !el.parentNode.classList.contains( 'autoplay-stop' ) ) {
          changeToFirstSlide( swiper, settings );
          startAutoPlay( swiper );
        }
        observer.unobserve( entry.target );
      } else {
        el.parentNode.classList.remove( 'tab-slider-in-view' );
        if ( settings.autoplay && !el.parentNode.classList.contains( 'autoplay-stop' ) ) {
          changeToFirstSlide( swiper, settings );
          stopAutoPlay( swiper );
        }
      }
    } );
  } );
  observer.observe( el );
};

const THUMB_ACTIVE_CLASS = 'swiper-slide-thumb-active';

function setThumbActiveImmediate( navSwiper, clickedSlide ) {
  if ( !navSwiper?.slides || !clickedSlide ) return;
  const index = Array.from( navSwiper.slides ).indexOf( clickedSlide );
  if ( index < 0 ) return;
  navSwiper.slides.forEach( ( slide, i ) => {
    slide.classList.toggle( THUMB_ACTIVE_CLASS, i === index );
  } );
}

function createNavClickHandler( settings, el, swiper, navSwiper ) {
  return ( evt ) => {
    const slide = evt.target?.closest?.( '.swiper-slide' );
    if ( !slide || !navSwiper.slides?.length ) return;
    const index = Array.from( navSwiper.slides ).indexOf( slide );
    if ( index < 0 ) return;
    console.log( '[tab-slider] Nav tab clicked', { index, slide } );
    setThumbActiveImmediate( navSwiper, slide );
    if ( settings.loop ) {
      swiper.slideToLoop( index );
    } else {
      swiper.slideTo( index );
    }
    handleInteraction( swiper, navSwiper, el );
  };
}

function setupTabSliderContent( settings, el, swiper, navSwiper ) {
  const animateDuration = settings.autoplay ? settings.autoplay.delay : 0;
  setAnimationDuration( navSwiper, animateDuration );
  stopAutoPlay( swiper );
  swiper.slideTo( 0 );

  if ( settings.autoplay ) {
    el.parentNode.classList.add( 'swiper-autoplay' );
  }

  navSwiper.el.addEventListener( 'click', createNavClickHandler( settings, el, swiper, navSwiper ) );
  swiper.on( 'touchEnd', () => handleInteraction( swiper, navSwiper, el ) );
  setupIntersectionObserver( el, swiper, navSwiper, settings );
  swiper.on( 'afterInit', ( contentSwiper ) => {
    const dots = contentSwiper.el.querySelectorAll( '.swiper-pagination-bullet' );
    handleDotsInteraction( contentSwiper, navSwiper, el, dots );
  } );
}

const initSliderContent = ( settings, el, swiper ) => {
  configureSwiper( settings, swiper );
  const navSwiper = swiper.thumbs.swiper;
  if ( swiper.el.closest( '.e-tbs .e-tbs__content' ) ) {
    setupTabSliderContent( settings, el, swiper, navSwiper );
  }
};

addAction( 'b3rg_tab_slider_content_init', 'b3rg/tab-slider', initSliderContent );

addAction( 'b3rg_tab_slider_nav_init', 'b3rg/tab-slider', ( settings, el, swiper ) => {
  configureSwiper( settings, swiper );
} );
